import { c as _c } from "react/compiler-runtime";
import { Body } from '../typography';
import { Alert, AlertDescription } from './Alert';
export interface TaskChip {
  code: string;
  description: string;
}
export interface TaskChipsProps {
  chips?: TaskChip[];
}

/** Renders task rejection reasons in a single destructive banner. */
export default function TaskChips(t0) {
  const $ = _c(4);
  const {
    chips
  } = t0;
  if (!chips?.length) {
    return null;
  }
  let t1;
  if ($[0] !== chips) {
    t1 = chips.map(_temp);
    $[0] = chips;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <Alert variant="destructive"><AlertDescription>{t1}</AlertDescription></Alert>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
function _temp(chip, index) {
  return <Body key={`${chip.code}-${index}`} size="sm">{chip.description}</Body>;
}